/**
 * モーダルプラグイン modaalの設定
 * https://github.com/humaan/Modaal
 */

$(document).ready(function () {
  // 動画用スクリプト
  $('.modal_video_01').modaal({
    content_source: '#inline_01',
    background_scroll: true
  });

});

$(document).ready(function () {
  // 動画用スクリプト
  $('.modal_video_02').modaal({
    content_source: '#inline_02',
    background_scroll: true
  });

});

// モーダル外の領域をクリックした際の処理
function handleOutsideClick(event) {
  // クリックされた要素が .modaal-container の子孫要素であるかを確認
  var isClickInsideModal = event.target.closest('.modaal-container');

  // クリックされた要素が .modaal-container の外部である場合、video タグを一時停止
  if (!isClickInsideModal) {
    var videoTags = document.querySelectorAll('.modaal-container video');
    videoTags.forEach(function (videoTag) {
      videoTag.pause();
    });
  }
}

// ドキュメント全体でクリックイベントを監視
document.addEventListener('click', handleOutsideClick);
